import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {gsap} from "utils/gsap";
import {media} from "utils/Media";
import {graphql, useStaticQuery} from "gatsby";
import CloseIcon from "images/cross-black.svg";
import NewSweepstake from "../Sweepstake/NewSweepstake";

const SignupStyles = styled.section`
  opacity: 0;
  visibility: hidden;
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, .7);
  z-index: 99999;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  .wrapper {
    --bs-bg-opacity: 1;
    background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
    max-width: 1090px;
    max-height: 90%;
    width: 90%;
    z-index: 1001;
    position: relative;

    .close {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      width: 32px;
      height: 32px;
      cursor: pointer;
      z-index: 999;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      @media ${media.md} {
        top: 1rem;
        right: 1rem;
        width: 40px;
        height: 40px;
      }
      @media ${media.lg} {
        background: none;
      }

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const ModalPopup = ({ path, data }) => {
  const [open, setOpen] = useState(false);

  const {
    displayCompetition,
    displayForm,
    mailchimpFieldKey,
    uniqueName,
    title,
    text,
    image,
    termsText,
    successText,
    redirect,
    redirectPage,
    pagesToDisplay,
    link
  } = data?.popup

  useEffect(() => {
    if (typeof window !== "undefined" && displayCompetition) {

      if (uniqueName) {
        const modalViewed = window.localStorage.getItem(`mado_${uniqueName}`)
      
        // display and launch  modal as nothing in localstorage
        if (!modalViewed) {
          setOpen(true)
        }

      } else {
        setOpen(true)
      }
    }
  }, [])

  const popUpRef = useRef();
  const q = gsap.utils.selector(popUpRef);
  const popUpAnimation = useRef();

  useEffect(() => {
    popUpAnimation.current = gsap
    .timeline({duration: 0.5, ease: "power1.out", stagger: 0.5})
    .to(popUpRef.current, {
      opacity: "1",
      visibility: "visible",
      // duration: 0.25,
    })
    .from(q(".wrapper"), {
      y: "-500px",
      opacity: "0",
      // duration: 0.25,
    });
    
    return () => {
      popUpAnimation.current.kill();
    };
  }, []);

  useEffect(() => {
    if (!open) {
      popUpAnimation.current.reverse();
      document.body.style.overflowY = "auto";
      if (uniqueName) {
        window.localStorage.setItem(`mado_${uniqueName}`, "true");
      }
    } else {
      popUpAnimation.current.play();
      document.body.style.overflow = "hidden";
    }
  }, [open]);

  if (displayCompetition) {
    return (
      <SignupStyles 
        ref={popUpRef}
        setOpen={setOpen}
        open={open}
      >
        <div className="wrapper">
          <NewSweepstake
            displayCompetition={displayCompetition}
            displayForm={displayForm}
            mailchimpFieldKey={mailchimpFieldKey}
            title={title}
            text={text}
            image={image}
            termsText={termsText}
            successText={successText}
            redirect={redirect}
            redirectPage={redirectPage}
            pagesToDisplay={pagesToDisplay}
            link={link}
            path={path}
          />
          <div className="close" onClick={() => setOpen(false)}>
            <img src={CloseIcon} alt=""/>
          </div>
        </div>
      </SignupStyles>
    );
  }
  return null
};


const Modal = ({ setCookie, ...props }) => {
  const data = useStaticQuery(graphql`
    query {
      allWpPopup {
        edges {
          node {
            acfPopup {
              popup {
                displayCompetition
                displayForm
                mailchimpFieldKey
                uniqueName
                title
                text
                image {
                  altText
                  caption
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 545, quality: 90, placeholder: NONE, layout: CONSTRAINED)
                    }
                  }
                }
                termsText
                successText
                redirect
                redirectPage {
                  ... on WpPage {
                    uri
                  }
                }
                link {
                  url
                  title
                  target
                }
                pagesToDisplay {
                  page {
                    ... on WpPage {
                      id
                      uri
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const modal = data.allWpPopup.edges.flatMap(({ node }, i) => {
    if (node.acfPopup.popup.pagesToDisplay.length > 0) {
      // Filter pages that match the current path
      const matchedPage = node.acfPopup.popup.pagesToDisplay.find(
        ({ page }) => page.uri === props.path
      );

      console.log(matchedPage)

      if (matchedPage) {
        return (
          <ModalPopup key={i} path={props.path} data={node.acfPopup} />
        );
      }
      
      return []; // Return empty array to prevent undefined values
    }

    // Global popup as no pagesToDisplay is set
    return <ModalPopup key={i} path={props.path} data={node.acfPopup} />;
  });

  return modal.length > 0 ? modal[0] : null;
}


export default Modal;